import type { ReactNode } from "react";

interface PageHeaderProps {
  /** Small uppercase line above the title: where you are. */
  eyebrow?: string;
  title: ReactNode;
  /** Shown beside the title but outside the heading, e.g. status badges. */
  titleExtra?: ReactNode;
  sub?: ReactNode;
  /** Buttons or a segmented control; full width under the title on phones. */
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, titleExtra, sub, actions }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div className="page-heading">
        {eyebrow ? <p className="page-eyebrow">{eyebrow}</p> : null}
        <div className="page-title">
          <h1>{title}</h1>
          {titleExtra}
        </div>
        {sub ? <p className="page-sub">{sub}</p> : null}
      </div>
      {actions ? <div className="page-actions">{actions}</div> : null}
    </div>
  );
}
